// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__136DB","list":"styles_list__1mGQl"};